/**
 * ServiceVideoSchema — JSON-LD via DOM injection (no Helmet).
 */
import { SITE_URL } from '@/lib/seo';
import { useLanguage } from '@/contexts/LanguageContextNew';
import { useSchemaDOM } from '@/hooks/useSchemaDOM';

interface ServiceVideoSchemaProps {
  serviceName: string;
  category: 'bpo' | 'digital' | 'consulting';
}

export function ServiceVideoSchema({ serviceName, category }: ServiceVideoSchemaProps) {
  const { language } = useLanguage();
  const slug = serviceName.toLowerCase().replace(/\s+/g, '-');

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: `${serviceName} — Call IT Dev ${category === 'bpo' ? 'BPO' : 'Digital Factory'}`,
    description: `Discover how Call IT Dev delivers enterprise-grade ${serviceName.toLowerCase()}.`,
    thumbnailUrl: `${SITE_URL}/og-image.png`,
    uploadDate: '2026-01-15',
    duration: category === 'bpo' ? 'PT3M15S' : 'PT4M00S',
    contentUrl: `${SITE_URL}/${language}/services/${category}/${slug}#video`,
    inLanguage: language,
    publisher: { '@type': 'Organization', '@id': `${SITE_URL}/#organization` },
  };

  useSchemaDOM([schema], `service-video-${slug}`, [language, serviceName]);
  return null;
}
